export default __webpack_public_path__ + "03314be05b5dfe78b449647f8c9d341e.png";